import api from "./api";

export const createSchedule = (funnelOpportunityId, data) => {
    if (funnelOpportunityId) {
        return api.post(`/funnel-opportunities/${funnelOpportunityId}/schedules`, data);
    } else {
        // Criar agendamento por contactId quando não há prospecção
        return api.post(`/contact-schedules`, data);
    }
};

export const listSchedules = (funnelOpportunityId, contactId) => {
    if (funnelOpportunityId) {
        return api.get(`/funnel-opportunities/${funnelOpportunityId}/schedules`);
    } else if (contactId) {
        // Buscar agendamentos por contactId quando não há prospecção
        return api.get(`/contact-schedules?contactId=${contactId}`);
    }
};
